import { useMutation } from '@cbgms/base/http/use-query'
import { DuplicationCheck } from '@cbgms/api'
import { useDuplicateCheckVAT } from 'app/auth/components/hooks/use-duplicate-checks'

export interface UseVATValidatorResult {
  isValid: boolean
  VATNumber: string
}

export interface VATInputSchema {
  VATNumber: string
}

// useVATValidatorBuilder builds a usMutation that can used in your components
export const useVATValidatorBuilder = (duplicateChecks: DuplicationCheck[], basePath: string) => {
  const handleDuplicateCheckVAT = useDuplicateCheckVAT(duplicateChecks, basePath)

  return useMutation(async ({ VATNumber }: VATInputSchema) => {
    if (!VATNumber) {
      return { isValid: true, VATNumber } as UseVATValidatorResult
    }
    await handleDuplicateCheckVAT(VATNumber)
    return { isValid: true, VATNumber } as UseVATValidatorResult
  })
}
